import request from "@/utils/request";

export function GetBranchPayments(branchId, fardId, startDate, endDate, skip) {
  let url = "/Payment/GetBranchPayments?$orderby=id desc";
  if (skip >= 0) {
    url += "&$top=10&$skip=" + skip;
  }
  return request({
    url: url,
    method: "post",
    data: {
      BranchId: branchId,
      fardId: fardId,
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function GetBranchTranasctions(branchId, fardID, startDate, endDate) {
  return request({
    url: "/Payment/GetBranchTranasctions",
    method: "post",
    data: {
      BranchId: branchId,
      FardId: fardID,
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function SaveByModirPayment(branchId, fardId, amount, description) {
  return request({
    url: "/Payment/SaveByModir",
    method: "post",
    data: {
      BranchId: parseInt(branchId),
      FardId: fardId,

      Amount: amount,
      Description: description,
    },
  });
}

export function DeletePayment(id) {
  return request({
    url: "/Payment/Delete",
    method: "post",
    data: {
      Id: id,
    },
  });
}

export function GetUserPayments(branchId, startDate, endDate, skip) {
  return request({
    url: "/Payment/GetUserPayments?$orderby=id desc&$top=10&$skip=" + skip,
    method: "post",
    data: {
      BranchId: branchId,
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function StartPayment(branchId, amount) {
  return request({
    url: "/Payment/StartPayment",
    method: "post",
    data: {
      BranchId: parseInt(branchId),
      Amount: amount,
    },
  });
}

export function CalculateCredit(branchId) {
  return request({
    url: "/Payment/CalculateCredit",
    method: "post",
    data: {
      BranchId: parseInt(branchId),
    },
  });
}

export function ImportExcel(branchId, file) {
  var fmData = new FormData();

  fmData.append("BranchId", parseInt(branchId));
  fmData.append("File", file);

  return request({
    url: "/Payment/Import",
    method: "post",
    data: fmData,
  });
}

export function GetAdminPardakhtList(skip) {
  let url = "/Payment/GetAdminPardakhtList";
  if (skip >= 0) {
    url += "?top=10&skip=" + skip;
  }
  return request({
    url: url,
    method: "post",
  });
}

export function GetAdminPardakhtDetail(pardakhtId) {
  return request({
    url: "/Payment/GetAdminPardakhtDetail",
    method: "post",
    data: {
      PardakhtId: pardakhtId,
    },
  });
}

export function GetSchoolPardakhtDetail(branchId, skip) {
  let url = "/Payment/GetSchoolPardakhtDetail";
  if (skip >= 0) {
    url += "?top=50&skip=" + skip;
  }
  return request({
    url: url,
    method: "post",
    data: {
      branchId: branchId,
    },
  });
}

export function GetSchoolAccount(schoolId) {
  return request({
    url: "/Payment/GetSchoolAccount",
    method: "post",
    data: {
      SchoolId: schoolId,
    },
  });
}

export function InsertPardakhtList() {
  return request({
    url: "/Payment/InsertPardakhtList",
    method: "post",
  });
}

export function ExportReportAsExcel(pardakhtId) {
  return request({
    url: "/Payment/ExportReportAsExcel?pardakht_id=" + pardakhtId,
    method: "post",
    responseType: "blob",
  });
}
